import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const Carousel = () => {
  return (
    <div className='relative'>
      {/* Banner superior */}
      <div className="absolute top-0 left-0 w-full z-10 bg-gradient-to-b from-black/70 to-transparent py-6 md:py-8">
        <div className="max-w-4xl mx-auto text-center px-2">
          <h1 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-2 md:mb-4">
            FRABAS
          </h1>
          <p className="text-base xs:text-lg sm:text-xl md:text-2xl text-white/90 font-semibold">
            UNA EMPRESA CON MÁS DE 20 AÑOS DE EXPERIENCIA EN MUDANZAS
          </p>
        </div>
      </div>
      <Swiper
        className='w-full h-[300px] xs:h-[350px] sm:h-[400px] md:h-[600px]'
        spaceBetween={10}
        slidesPerView={1}
        autoplay={{ delay: 3000 }}
        navigation={true}
        modules={[Navigation, Pagination, Autoplay]} 
      >
        <SwiperSlide>
          <div className="relative w-full h-[300px] xs:h-[350px] sm:h-[400px] md:h-[600px]">
            <img
              src="/camiones/camion 1.jpg"
              alt="Imagen 1"
              className="w-full h-full object-cover rounded-none"
            />
            <div className="absolute inset-0 bg-black/30"></div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="relative w-full h-[300px] xs:h-[350px] sm:h-[400px] md:h-[600px]">
            <img
              src="/camiones/camion2.jpg"
              alt="Imagen 2"
              className="w-full h-full object-cover rounded-none"
            />
            <div className="absolute inset-0 bg-black/30"></div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="relative w-full h-[300px] xs:h-[350px] sm:h-[400px] md:h-[600px]">
            <img
              src="/camiones/camion3.png"
              alt="Imagen 3"
              className="w-full h-full object-cover rounded-none"
            />
            <div className="absolute inset-0 bg-black/30"></div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="relative w-full h-[300px] xs:h-[350px] sm:h-[400px] md:h-[600px]">
            <img
              src="/camiones/camion1.png"
              alt="Imagen 4"
              className="w-full h-full object-cover rounded-none"
            />
            <div className="absolute inset-0 bg-black/30"></div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="relative w-full h-[300px] xs:h-[350px] sm:h-[400px] md:h-[600px]">
            <img
              src="/camiones/camion 6.jpg"
              alt="Imagen 5"
              className="w-full h-full object-cover rounded-none"
            />
            <div className="absolute inset-0 bg-black/30"></div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="relative w-full h-[300px] xs:h-[350px] sm:h-[400px] md:h-[600px]">
            <img
              src="/camiones/camion3.png"
              alt="Imagen 6"
              className="w-full h-full object-cover rounded-none"
            />
            <div className="absolute inset-0 bg-black/30"></div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default Carousel;